import { DIC } from "@/const/dic";

export const appointmentCardDetailOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: false,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  menuWidth: "150",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "预约卡ID",
      prop: "id",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "店铺名称",
      prop: "shopName",
      type: "input",
      span: 13,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "预约卡号",
      prop: "cardNumber",
      type: "input",
      span: 13,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "店铺ID",
      prop: "shopId",
      type: "input",
      hide: "true",
      span: 13,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "使用状态",
      prop: "useStatus",
      type: "select",
      span: 13,
      search: true,
      placeholder: "请选择使用状态",
      dicData: DIC.USE_STATUS,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "预约卡状态",
      prop: "cardStatus",
      span: 13,
      type: "select",
      search: true,
      placeholder: "请选择预约卡状态",
      dicData: DIC.CARD_STATUS,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "分配时间",
      prop: "createTime",
      type: "datetime",
      // sortable: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "使用时间",
      prop: "useTime",
      type: "datetime",
      // sortable: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "分配人",
      prop: "createBy",
      type: "input",
      span: 13,
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
